import type { ReactNode } from 'react';
import { RouteEntry } from '@/components/layout/RouteEntry';

/** Commit the route before doing the portfolio's first render (#990): the
 *  outgoing dashboard's live updates would otherwise starve it. The mechanism
 *  and its invariants live in `RouteEntry`. */
export function PositionTrackerEntry({ children }: { children: ReactNode }) {
  return <RouteEntry label="Position Tracker">{children}</RouteEntry>;
}
